<script>
    import CONSTANTS from '../constants'

    export default {
        name: 'AppFab',
        props: {
            icon: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            color: {
                type: String,
                default: CONSTANTS.MAIN_BACKGROUND
            },
            loading: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            btnBindings() {
                return {
                    color: this.color,
                    fixed: true,
                    bottom: true,
                    left: this.$vuetify.breakpoint.smAndDown,
                    small: this.$vuetify.breakpoint.smAndDown,
                    fab: true,
                    disabled: this.disabled
                }
            },
            iconBindings() {
                return {
                    color: this.$vuetify.theme.dark ? CONSTANTS.MAIN_COLOR_DARK : CONSTANTS.MAIN_COLOR
                }
            }
        }
    }
</script>

<template>
    <VFabTransition>
        <VBtn id="app-fab" v-bind="btnBindings" :loading="loading" @click.left="$emit('click')">
            <VIcon v-bind="iconBindings" v-text="icon"/>
        </VBtn>
    </VFabTransition>
</template>

<style>
    .v-btn--fixed.v-btn--bottom.v-size--small {
        bottom: 36px;
    }
</style>
